import { render, staticRenderFns } from "./LocationSelectedDelivery.vue?vue&type=template&id=42378fc8&"
import script from "./LocationSelectedDelivery.vue?vue&type=script&lang=js&"
export * from "./LocationSelectedDelivery.vue?vue&type=script&lang=js&"
import style0 from "./LocationSelectedDelivery.vue?vue&type=style&index=0&id=42378fc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonIcon: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/Icon/index.vue').default})
